import { useChangeSearch, useFilter, useSearch } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Text } from '../../../components/presentation/Text'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import AssetsLoader from '../_load/AssetsLoader'
import SearchInput from '../../../components/form/SearchInput'
import SelectAllSwitch from '../../../components/form/SelectAllSwitch'
import Separator from '../../../components/helpers/Separator'
import ToRight from '../../../components/helpers/ToRight'

const ControlBar = ({ selectedLabel, useSelectAll, disabledLoader, ignoreSegments = false, ...props }) => {
  const { t } = useTranslation()
  const changeSearch = useChangeSearch()
  const search = useSearch()
  const filter = useFilter()

  const rightComponent = useSelectAll && <SelectAllSwitch value={props.value} onChange={props.onChange} />
  return (
    <div>
      <FlexGrid justify="space-between" gutter={0.5} wrap>
        <FlexCol flex={1} wrapOn="sm">
          <SearchInput onStopTyping={changeSearch} value={search} />
        </FlexCol>
        <FlexCol flex={1} hideOn="sm" />
        <FlexCol flex={1}>
          <ToRight>{rightComponent}</ToRight>
        </FlexCol>
      </FlexGrid>

      <Separator weight={4} />

      <FlexGrid align="flex-start" justify="flex-start" gutter={0.2}>
        <Text>{selectedLabel ? t('selected') : t('selectOne')}: </Text>
        <Text inlineBlock bold>
          {selectedLabel}
        </Text>
      </FlexGrid>

      <Separator weight={4} />

      <AssetsLoader
        ignoreSegments={ignoreSegments}
        type={filter.type}
        search={search}
        disabled={disabledLoader}
        sortByLevel
        {...props}
      />
    </div>
  )
}

export default ControlBar
